export const useCalendarRange = (
  params: any,
  range: number = 7,
) => {
  let pickDay: Date;
  range = range * 24 * 60 * 60 * 1000;
  const calendarChange = (val: Date[]) => {
    [pickDay] = val;
  };
  const disabledDate = (time: number) => {
    if (!pickDay) {
      return false;
    }
    const pickTime = new Date(pickDay).getTime();
    const preTime = pickTime - range;
    const sufTime = pickTime + range;
    return time < preTime || time > sufTime;
  };
  const createdTimeChange = () => {
    if (!params.value.createdTime) {
      pickDay = undefined!;
    }
  };

  return {
    calendarChange,
    disabledDate,
    createdTimeChange,
  };
};
